export default __webpack_public_path__ + "static/custom-tooltips-bab2ef90227ea4b997e561301808e3cd.png";